import { getProjectsVenue } from '@/domain/project-venue/actions/get-projects-venue.action';
import { SnackbarGateway } from '@/domain/snackbar/gateways/snackbar.gateway';
import { createAppAsyncThunk } from '@/domain/store.thunk';
import { translate } from '@/ui/i18n';

export const deleteProjectVenue = createAppAsyncThunk(
  'projectVenue/deleteProjectVenue',
  async (
    id: number,
    { extra: { projectVenueGateway, snackbarGateway }, dispatch },
  ): Promise<void> => {
    try {
      await projectVenueGateway.delete(id);
      showSnackbarSuccess(snackbarGateway);
      dispatch(getProjectsVenue());
    } catch (error) {
      showSnackbarError(snackbarGateway);
      throw error;
    }
  },
);

function showSnackbarSuccess(snackbarGateway: SnackbarGateway) {
  snackbarGateway.success(translate('DeleteProject.Message.success'));
}

function showSnackbarError(snackbarGateway: SnackbarGateway) {
  snackbarGateway.error(translate('DeleteProject.Message.error'));
}
